<template>
  <div class="all-vitamins">
    <nav class="tabnav bordered tab-nav mb-0">
      <template v-for="(vitamin,ind) in vitamins">
        <button
          :class="(ind === activeVitamin ? 'active' : '')"
          :style="'color:white;background-color:'+colors[ind]"
          @click.stop.prevent="setActiveVitamin(ind)"
          class="flex-grow-1 btn-link btn tab-link">
<!--          {{// truncate(vitamin.Title,12,'string')}}-->
          {{localizedField(vitamin,'Title')}}
          <!--          @click.stop.prevent="activeVitamin = ind"-->
        </button>
      </template>
    </nav>
    <div style="min-height:30vh" id="accordion-summary">
      <template v-for="(vitamin,i) in vitamins">
        <vitamin-review class="tb-content pt-3"
                        :graph-field="graphField"
                        :review-type="type"
                        :submission="submission"
                        v-show="activeVitamin === i"
                        :scores="scoreForVitamin(vitamin.id)"
                        :vitamin="vitamin"></vitamin-review>
      </template>
    </div>
  </div>
</template>

<script>

  import VitaminReview from "./VitaminReview";
  import GenericChart from "../Charts/GenericChart";

  export default {
    components: {
      VitaminReview,
      GenericChart
    },
    methods: {
      setActiveVitamin(i) {
        // console.log('emitting clickVitamin',i)
        this.$emit('clickVitamin',i)
        this.activeVitamin = i;
      },
      scoreForVitamin(vitamin_id) {
        // console.log('scoreforvitamin',[vitamin_id,this.scores])
        let score = {}
        this.scores.forEach(vitaminScore => {
          if (vitamin_id === vitaminScore.id) {
            score = vitaminScore
          }
          // console.log('score for vitamin',[vitaminScore,vitamin_id])
        });

        return score
      }
    },
    computed: {
      vitaminLabels() {
        const labels = []
        this.vitamins.forEach(vitamin => {
          labels.push(this.localizedField(vitamin,'Title'))
        });
        return labels
      },
      submissionIds() {
        const ids = []
        this.submissions.forEach(submission => {
          if (submission) {
            ids.push(submission.id)
          }
        });
        return ids
      }
    },
    created() {
      // this.getVitamins()
    },
    data() {
      return {
        // vitamins: [],
        activeVitamin: 0,
      }
    },
    watch: {
      activeVitamin() {
        // console.log('active vitamin changed', this.activeVitamin)
      }
    },
    props: {
      graphField: {
        type: String,
        default() {
          return 'average'
        }
      },
      type: {
        type: String,
        default() {
          return 'team'
        }
      },
      scores: {
        type: Array
      },
      vitamins: {
        type: Array,
        default() {
          return []
        }
      },
      submission: {
        type: Object,
        default() {
          return null
        }
      },
      // submissions: { //if review for 1 user, this is only 1 submission, otherwise it contains submissions for all team members
      //   type: Array,
      //   default() {
      //     return []
      //   }
      // }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Review/AllVitamins.vue